import type { MouseEvent } from 'react'

/** Re-export Virtual Element from popper */
export { type VirtualElement } from '@popperjs/core'

export const createVirtualElement = (ev: MouseEvent) => ({
  getBoundingClientRect: () => ({
    right: ev.clientX,
    bottom: ev.clientY,
    left: ev.clientX,
    top: ev.clientY,
    width: 0,
    height: 0,
    x: ev.clientX,
    y: ev.clientY,
    toJSON: () => '',
  }),
})
